import first from "lodash/first";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { quizPostiesQuizArticle$key } from "scmp-app/queries/__generated__/quizPostiesQuizArticle.graphql";

import { PostiesQuizContextProvider } from "./contexts";
import { PostiesQuizWidget } from "./quiz-widget";

export type Props = {
  className?: string;
  reference: quizPostiesQuizArticle$key;
};

export const PostiesQuiz: FunctionComponent<Props> = ({ className, reference }) => {
  const article = useFragment(
    graphql`
      fragment quizPostiesQuizArticle on Article {
        quizIds
      }
    `,
    reference,
  );
  const firstQuizId = first(article?.quizIds ?? []) ?? undefined;

  return (
    <PostiesQuizContextProvider quizId={firstQuizId}>
      <PostiesQuizWidget className={className} />
    </PostiesQuizContextProvider>
  );
};

PostiesQuiz.displayName = "PostiesQuiz";
